@if (event) {
  <div
    class="table-event-card border rounded-2 p-3 bg-body-tertiary"
    [class.table-event-card-clickable]="!!event.id"
    [attr.tabindex]="event.id ? 0 : null"
    [attr.aria-label]="event.id ? 'Apri dettaglio dell\'evento ' + event.name : null"
    (click)="onCardClick($event)"
    (keydown)="onCardKeydown($event)"
  >
    <div class="d-flex justify-content-between align-items-start gap-3 mb-2">
      <div class="flex-grow-1">
        <h6 class="h6 fw-bold mb-1">{{ event.name }}</h6>
        @if (geoLocationService.locationSubtitle(event.location)) {
          <p class="small mb-0 text-muted">{{ geoLocationService.locationSubtitle(event.location) }}</p>
        } @else {
          <p class="small mb-0 text-muted">{{ geoLocationService.locationTitle(event.location) }}</p>
        }
      </div>
      <span class="badge small text-nowrap text-uppercase"
            [ngClass]="event.active ? 'bg-success-subtle text-success-emphasis' : 'bg-secondary-subtle text-secondary-emphasis'">
        {{ event.active ? 'Attivo' : 'Non attivo' }}
      </span>
    </div>

    <div class="row row-cols-auto gap-3 py-2 border-top border-bottom">
      <div class="d-flex flex-column col">
        <span class="stat-label small fw-bold text-uppercase">Data</span>
        <span class="stat-value fw-bold">{{ event.startDate | dateRange:event.endDate }}</span>
      </div>

      @if (geoLocationService.mapsUrl(event.location)) {
        <div class="d-flex flex-column col">
          <span class="stat-label small fw-bold text-uppercase">Località</span>
          <a class="fw-bold link-primary text-decoration-none" [href]="geoLocationService.mapsUrl(event.location)" target="_blank" rel="nofollow noopener noreferrer">
            {{ geoLocationService.mapsLinkLabel(event.location) }}
          </a>
        </div>
      }
    </div>

    <div class="d-flex justify-content-end mt-2">
      @if (event.id) {
        <a [routerLink]="['/events/detail', event.id]"
           class="btn btn-link btn-sm d-inline-flex align-items-center gap-2 text-decoration-none">
          Dettagli evento
          <i class="bi bi-chevron-right small"></i>
        </a>
      } @else {
        <button class="btn btn-link btn-sm" type="button" disabled>Dettagli evento non disponibili</button>
      }
    </div>
  </div>
}
